import {Injectable} from '@angular/core';
import {HttpService} from '@core/backend/common/api/http.service';
import {Observable} from 'rxjs';
import {APIResponse} from '@core/interfaces/system/system-common';
import {
    CheckRuleNameExistsRequest,
    FieldDto,
    FieldRequest,
    FullRuleDto,
    Rule,
    RuleDiscriminator,
    RuleField,
    RuleFilterOptionResult,
    RuleType,
} from '@core/interfaces/engin/inspection-rules/rules';

@Injectable()
export class RulesApi {
    private readonly prefix = 'rules';

    constructor(private api: HttpService) {}

    // app-approve inspection
    getRuleList(applyTo: RuleDiscriminator): Observable<APIResponse<Rule[]>> {
        return this.api.get(`${this.prefix}/list/${applyTo}`);
    }

    getRuleById(ruleId: number): Observable<APIResponse<FullRuleDto>> {
        return this.api.get(`${this.prefix}/${ruleId}`);
    }

    editRuleById(rule: FullRuleDto): Observable<APIResponse<FullRuleDto>> {
        return this.api.put(`${this.prefix}/${rule.id}`, rule);
    }

    duplicateRuleById(ruleId: number): Observable<APIResponse<FullRuleDto>> {
        return this.api.post(`${this.prefix}/duplicate/${ruleId}`);
    }

    deleteRuleById(ruleId: number): Observable<APIResponse<Rule>> {
        return this.api.delete(`${this.prefix}/${ruleId}`);
    }

    createRule(rule: FullRuleDto): Observable<APIResponse<FullRuleDto>> {
        return this.api.post(`${this.prefix}`, rule);
    }

    executeRuleById(ruleId: number): Observable<APIResponse<boolean>> {
        return this.api.post(`${this.prefix}/execute/${ruleId}`);
    }

    executeAutoRuleById(ruleId: number, activeMode: boolean): Observable<APIResponse<any>> {
        return this.api.get(`${this.prefix}/${ruleId}/activate/${activeMode}`);
    }

    getResultAffectedByRule(req: FullRuleDto): Observable<APIResponse<number>> {
        return this.api.post(`${this.prefix}/results`, req);
    }

    getFieldTypeList(): Observable<APIResponse<RuleField[]>> {
        return this.api.get(`${this.prefix}/fields/field-types`);
    }

    getFieldNameListByType(req: FieldRequest): Observable<APIResponse<FieldDto[]>> {
        // need to query it in url
        return this.api.post(`${this.prefix}/fields/names`, req);
    }

    getFieldValueListByName(req: FieldRequest): Observable<APIResponse<RuleFilterOptionResult[]>> {
        return this.api.post(`${this.prefix}/fields/names/values`, req);
    }

    getInspectionNameList(ruleType: RuleType): Observable<APIResponse<FieldDto[]>> {
        return this.api.get(`${this.prefix}/inspection-results/fields/rule-type/${ruleType}`);
    }

    checkExistingRuleName(req: CheckRuleNameExistsRequest): Observable<APIResponse<boolean>> {
        return this.api.post(`${this.prefix}/check-name`, req);
    }
    getInspectionValueListByName(req: FieldRequest): Observable<APIResponse<any[]>> {
        return this.api.post(`${this.prefix}/inspection-results/fields/values`, req);
    }
    updateRuleListOrder(ruleList: Rule[]): Observable<APIResponse<boolean>> {
        return this.api.put(`${this.prefix}/rule-order`, ruleList);
    }
}
